import { createRoute } from '@/utils/routing'

export const SWIFT_MESSAGE_ORDER_LIST_ROUTE = 'swift-message-orders'
export const SWIFT_MESSAGE_ORDER_CREATE_ROUTE = 'swift-message-orders-create'
export const SWIFT_MESSAGE_ORDER_VIEW_ROUTE = 'swift-message-orders-swiftMessageOrderId'

function createRouteWithSwiftMessageOrderId (name, swiftMessageOrderId, options) {
  if (swiftMessageOrderId != null) {
    return createRoute(name, {
      params: { ...options.params, swiftMessageOrderId },
      query: options.query
    })
  }
}

export function createSwiftMessageOrderListRoute (options = {}) {
  return createRoute(SWIFT_MESSAGE_ORDER_LIST_ROUTE, options)
}

export function createSwiftMessageOrderCreateRoute (options = {}) {
  return createRoute(SWIFT_MESSAGE_ORDER_CREATE_ROUTE, options)
}

export function createSwiftMessageOrderViewRoute (swiftMessageOrderId, options = {}) {
  return createRouteWithSwiftMessageOrderId(SWIFT_MESSAGE_ORDER_VIEW_ROUTE, swiftMessageOrderId, options)
}
